export default __webpack_public_path__ + "static/media/runningMeasure.dc5cd8fa.png";